import { Fragment } from "react";

const color = (s, selected) => {
  if (s.occupied) return "bg-slate-400 text-transparent cursor-not-allowed";
  if (selected) return "bg-[#EC5B24] text-white border-[#EC5B24] scale-105";
  if (s.kind === "legroom") return "bg-amber-200 border-amber-300 hover:bg-amber-300";
  if (s.kind === "preferred") return "bg-blue-200 border-blue-300 hover:bg-blue-300";
  if (s.kind === "standard") return "bg-sky-100 border-sky-200 hover:bg-sky-200";
  return "bg-slate-100 border-slate-200 hover:bg-slate-200";
};

export const SeatMap = ({ map, selected, max, onToggle, money }) => {
  const cols = map.cols.split("");
  const aisles = new Set(map.aisles);
  const template = cols.map((_, i) => (aisles.has(i) ? "1.25rem 2rem" : "2rem")).join(" ");
  const cells = (render, aisle) => cols.map((c, i) => (
    <Fragment key={c}>{aisles.has(i) && aisle}{render(c, i)}</Fragment>
  ));
  return (
    <div data-testid="seat-map">
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs mb-4">
        {[["bg-slate-100", "Free"], ["bg-sky-100", "Window ₹199"], ["bg-blue-200", "Preferred ₹299-349"], ["bg-amber-200", "Extra legroom ₹499-699"], ["bg-slate-400", "Occupied"], ["bg-[#EC5B24]", "Your seat"]].map(([c, l]) => (
          <span key={l} className="flex items-center gap-1.5"><span className={`h-3.5 w-3.5 rounded ${c}`} /> {l}</span>
        ))}
      </div>
      <div className="mx-auto w-fit max-w-full overflow-x-auto bg-white border-2 border-slate-200 rounded-t-[80px] px-4 sm:px-6 pt-10 pb-6 max-h-[460px] overflow-y-auto">
        <div className="text-center text-[10px] uppercase tracking-widest text-slate-400 mb-4">Front · {map.airplane || "Aircraft"}</div>
        <div className="grid gap-1.5 text-center text-[10px] text-slate-400 mb-1" style={{ gridTemplateColumns: template }}>
          {cells((c) => <span>{c}</span>, <span />)}
        </div>
        {map.rows.map((r) => (
          <div key={r.row}>
            {r.row === 12 && <div className="text-[9px] text-center text-red-400 font-bold tracking-widest my-1">EXIT ← → EXIT</div>}
            <div className="grid gap-1.5 mb-1.5" style={{ gridTemplateColumns: template }}>
              {cells((c, i) => {
                const s = r.seats[i];
                const sel = selected.includes(s.id);
                return (
                  <button disabled={s.occupied} data-testid={`seat-${map.slice}-${s.id}`} title={`${s.id} · ${s.price ? money(s.price) : "Free"}`}
                    onClick={() => (sel || selected.length < max) && onToggle(s)}
                    className={`h-8 w-8 rounded-t-lg rounded-b-sm border text-[9px] font-bold transition-[transform,background-color] ${color(s, sel)}`}>
                    {sel ? s.id : ""}
                  </button>
                );
              }, <span className="text-[10px] text-slate-400 grid place-items-center">{r.row}</span>)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
